import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { cardCategories, cardExamples, volumes } from '../data/content';
export function Volumes() {
  return <section id="contenido" className="w-full bg-cream py-16 md:py-20" data-id="element-228" data-mp="184ogsuft62ye">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-229" data-mp="1c5gsduc5kjxu">
        <SectionHeading eyebrow="El sistema completo" title={<>
              Todo lo que <span className="italic text-gold-700" data-id="element-231" data-mp="1zt8efpnhwbcb">recibís</span>
            </>} data-id="element-230" data-mp="1c5qgtdhjuj1f" />

        <ol className="mt-12 space-y-6" data-id="element-232" data-mp="24rs2pwpk9z7u">
          {volumes.map(volume => {
          const isCards = volume.tag === 'Tomo 4';
          return <li key={volume.tag} className="overflow-hidden rounded-xl bg-white shadow-card ring-1 ring-plum-100" data-id="element-233" data-mp="1vsen0maugeeo">
                <div className={`h-1.5 w-full ${volume.accent}`} aria-hidden="true" data-id="element-234" data-mp="ke18i81zdbbb" />

                <div className="p-6 md:p-8" data-id="element-235" data-mp="3o86nkfg5vya6">
                  <header className="mx-auto max-w-2xl text-center" data-id="element-236" data-mp="3o8y7gt0ec7km">
                    <p className={`inline-flex rounded-full px-4 py-1.5 text-[0.7rem] font-bold uppercase tracking-[0.16em] ${volume.chip}`} data-id="element-237" data-mp="3j9lm6cp6b8k5">
                      {volume.tag}
                    </p>
                    <h3 className="mt-4 font-display text-[1.7rem] font-extrabold leading-tight tracking-tight text-plum-700 md:text-[2rem]" data-id="element-238" data-mp="3t5oopjnxt97m">
                      {volume.title}
                    </h3>
                    <p className="mt-2 text-[1.05rem] text-muted" data-id="element-239" data-mp="62a355d67og0">{volume.subtitle}</p>
                  </header>

                  <div className="mt-7 grid gap-7 lg:grid-cols-2 lg:gap-12" data-id="element-240" data-mp="ktiy7tzue20j">
                    <div className="space-y-4" data-id="element-241" data-mp="fsvabh6wu1aj">
                      <p className="leading-relaxed text-ink" data-id="element-242" data-mp="truyyoufag6p">{volume.intro}</p>

                      {isCards && <>
                          <ul className="grid grid-cols-2 gap-x-6 gap-y-2.5 sm:grid-cols-3" data-id="element-243" data-mp="ps43i7tybbvu">
                            {cardCategories.map(category => <li key={category.label} className="flex items-center gap-2.5" data-id="element-244" data-mp="11sasd8lvgwvu">
                                <span className={`h-3 w-3 shrink-0 rounded-full ${category.dot}`} aria-hidden="true" data-id="element-245" data-mp="16rdlpvshpenz" />
                                <span className="text-sm font-semibold text-ink" data-id="element-246" data-mp="1fj75rs7897ib">
                                  {category.label}
                                </span>
                              </li>)}
                          </ul>

                          <ul className="space-y-2.5" data-id="element-247" data-mp="1uhhra8p8nohm">
                            {cardExamples.map(example => <li key={example} className="rounded-lg border-l-2 border-gold-500 bg-gold-50 px-4 py-3 text-[0.95rem] italic leading-relaxed text-ink" data-id="element-248" data-mp="3rab7wqp548i5">
                                “{example}”
                              </li>)}
                          </ul>
                        </>}
                    </div>

                    <div className="rounded-xl bg-cream p-5 md:p-6" data-id="element-249" data-mp="1zmbsco78rhai">
                      <p className="mb-3.5 text-[0.7rem] font-bold uppercase tracking-[0.16em] text-gold-700" data-id="element-250" data-mp="1zo6bbwyyczby">
                        Qué incluye
                      </p>
                      <ul className="space-y-2.5" data-id="element-251" data-mp="2scbxmo5nmwdw">
                        {volume.items.map(item => <li key={item} className="flex items-start gap-3" data-id="element-252" data-mp="2nact3ay6htfd">
                            <CheckIcon className="mt-1 h-5 w-5 shrink-0 text-teal-500" aria-hidden="true" data-id="element-253" data-mp="2idmgwyphvhz8" />
                            <span className="text-ink" data-id="element-254" data-mp="16xehv799uosb">{item}</span>
                          </li>)}
                      </ul>
                      <p className="mt-5 border-t border-plum-100 pt-4 text-[0.7rem] font-bold uppercase tracking-[0.14em] text-muted" data-id="element-255" data-mp="2us9d3cdjeu0v">
                        {volume.value}
                      </p>
                    </div>
                  </div>
                </div>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}